import {ArticleTables} from './ArticleTables';
export default ArticleTables;
